import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';

export function DashboMCPUpgrade() {
    const { t } = useTranslation();

    const handleUpgradeClick = (e) => {
        e.preventDefault();
        const message = t('dashbo_mcp.upgrade.intercom_message');
        if (typeof window.Intercom === 'function') {
            window.Intercom('showNewMessage', message);
        }
    };

    const benefits = [
        t('dashbo_mcp.upgrade.benefit1'),
        t('dashbo_mcp.upgrade.benefit2'),
        t('dashbo_mcp.upgrade.benefit3'),
        t('dashbo_mcp.upgrade.benefit4'),
    ].filter(Boolean);

    return (
        <div className="dashbo-mcp-upgrade">
            <div className="upgrade-icon"><FaIcon iconName="microchip"/></div>
            <h2>{t('dashbo_mcp.upgrade.title')}</h2>
            <p className="upgrade-subtitle">{t('dashbo_mcp.upgrade.subtitle')}</p>
            <ul className="benefits-list">
                {benefits.map((b, i) => (
                    <li key={i}><FaIcon iconName="check" className="benefit-check"/> {b}</li>
                ))}
            </ul>
            <button
                type="button"
                className="btn -alt"
                onClick={handleUpgradeClick}
            >
                {t('dashbo_mcp.upgrade.cta')}
            </button>
        </div>
    );
}
